module.exports = __webpack_public_path__ + "img/pchomeain.3d14b552.svg";